import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../../AxiosCoreInterceptor";
import {
    VerificationDataPageSubmission
} from "../../../Model/Dto/VerificationAgency/VerificationDataPageSubmission";
import * as ApiUrls from './ApiUrl.VerificationDataPageSubmission';
import { SearchResult } from "../../../Model/Dto/SearchResult";

export const VerificationDataPageSubmissionService = {
    SearchIncomingSubmissions: (searchRequest: VerificationDataPageSubmission.SearchRequest): Promise<AxiosResponse<SearchResult<VerificationDataPageSubmission.DataPagesSearchResult>>> =>
        axiosCoreInstance.post(`${ApiUrls.VerificationDataPageSubmissionSearch}`, searchRequest),
    UpdateSubmissionStatus: (updateDto: VerificationDataPageSubmission.UpdateDto):  Promise<AxiosResponse<void>> =>
        axiosCoreInstance.put(`${ApiUrls.VerificationDataPageSubmission}`,updateDto),
    GetSubmissionById: (id: number): Promise<AxiosResponse<VerificationDataPageSubmission.SubmissionDtoIn>> => 
        axiosCoreInstance.get(`${ApiUrls.VerificationDataPageSubmission}${id}`),
    GetDataPageLockMetaForImport: (scorecardId: string): Promise<AxiosResponse<VerificationDataPageSubmission.DataPageLockImportMeta[]>> =>
        axiosCoreInstance.get(`${ApiUrls.VerificationDataPageLockMetaForImport}/${scorecardId}`),

};
